var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Alert',{attrs:{"type":"warning"}},[_c('p',[_vm._v(_vm._s(_vm.$t('exportWorkspaceModalWarning.message')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }